import { ApisauceInstance } from 'apisauce';

import shareExportedReport from '../../api/shareExportedReport';
import captureException from '../../services/captureException';

// Shares an exported report and, on the headless (scheduled) path, throws on a
// non-OK response so the failure propagates out through
// window.__fleetopsExportReport. That lets the renderer release its
// emailDelivered claim (tools/report-renderer/src/renderReport.ts) and Cloud
// Tasks retry, instead of a failed send being silently recorded as a success.
// Interactive shares keep their existing behaviour: the error is captured to
// Sentry but not thrown.
const shareReportOrThrow = async ({
  exportData,
  api,
  headless,
}: {
  exportData: ReportExportBody;
  api: ApisauceInstance;
  headless: boolean;
}) => {
  const response = await shareExportedReport(exportData, api);
  if (!response.ok) {
    captureException(new Error('Report export failed'));
    if (headless) {
      throw new Error(
        `Report export failed: ${response.status ?? 'no-status'} ${
          response.problem ?? ''
        }`.trim(),
      );
    }
  }
  return response;
};

export default shareReportOrThrow;
